import React, { useEffect, useState } from "react";


function Testimonials() {
  const testimonials = [
    { 
      name: "Rachel.", 
      feedback: "Essential and Assuring. You really stood in the gap of so much pain and agony. I think Mum went knowing she was deeply cared for",
    },
    { 
      name: "Madhvi.", 
      feedback: "Time and quality care for my dad, the nurses were very professional. Would highly recommend.", 
    },
    { 
      name: "Dipika.", 
      feedback: "Wholistic did a great job taking care of both mum and dad, great service delivery, warmth of staff also brilliant.",
    },
    { 
      name: "GM.", 
      feedback: "All rounded care for our sister, we loved every thing about the company and what they stood for.",
    }
  ];

  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent(prev => (prev + 1) % testimonials.length);
    }, 5000); // Change testimonial every 5 seconds

    return () => clearInterval(interval);
  }, [testimonials.length]);

  return (
    <div className="testimonials-page  ">
      <h1 className="testimonials-title">What Our Clients Say</h1>
      <p className="testimonials-subtitle">Real stories from families we've helped.</p>

      <div className="testimonial-slider">
        {testimonials.map((testimonial, index) => (
          <div 
            key={index} 
            className={`testimonial-card ${index === current ? "active" : ""}`}
          >
            <img src={testimonial.image} alt={testimonial.name} className="testimonial-image" />
            <p className="testimonial-feedback">"{testimonial.feedback}"</p>
            <h4 className="testimonial-name">- {testimonial.name}</h4>
          </div>
        ))}
      </div>

      {/* Navigation Dots */}
      <div className="testimonial-dots">
        {testimonials.map((_, index) => (
          <span 
            key={index} 
            className={`dot ${index === current ? "active" : ""}`}
            onClick={() => setCurrent(index)}
          ></span>
        ))}
      </div>
    </div>
  );
}

export default Testimonials;
